// wjk 2017/11/27
import uMessage from 'components/message'
import { forEach } from 'lodash'
/* global ko  __ */
let editpage
// 进度条数据处理
function progressDate (certDueStep) {
  if (certDueStep == '') {
    return []
  }
  let progressdate = []
  let arr = []
  let objBegin = {}
  let objFinsh = {}
  if (certDueStep == 1) {
    arr.push(certDueStep)
  } else {
    arr = certDueStep.split(',')
  }
  // debugger
  objBegin.num = '0'
  objBegin.text = '开始'
  progressdate.push(objBegin)
  forEach(arr, function (value, index) {
    // debugger
    let obj = {}
    switch (value) {
      case '1':
        obj.num = value
        obj.text = '资质审核'
        progressdate.push(obj)
        break
      case '2':
        obj.num = value
        obj.text = '现场认证'
        progressdate.push(obj)
        break
      case '3':
        obj.num = value
        obj.text = '产品试验'
        progressdate.push(obj)
        break
    }
  })
  objFinsh.num = '4'
  objFinsh.text = '完成'
  progressdate.push(objFinsh)
  return progressdate
}
function editShow (certCurrentStep, certClickStep) {
  // 判断跳转的页面是编辑还是浏览页面
  let edit
  if (certCurrentStep > certClickStep) {
    edit = false
  } else {
    edit = true
  }
  return edit
}
export default function (params) {
  // debugger
  // if (params.certDueStep2() != '') {
  this.certDueStep = ko.computed(() => {
    return progressDate(params.certDueStep())
  })
  // }
  this.certCurrentStep = params.certCurrentStep
  this.certClickStep = params.certClickStep
  this.qualifyCheckId = params.qualifyCheckId
  this.applyFieldId = params.applyFieldId
  this.productTestId = params.productTestId
  this.applyId = params.applyId
  this.progressClick = function (row) {
    // debugger
    if (this.certCurrentStep() >= row.num) {
      var url
      switch (row.num) {
        case '0':
          url = `../ag_hierarchicalEdit/index.${__('locale')}.html?id=` + this.applyId() + '&editpage=true'
          window.location.href = url
          break
        case '1' :
          this.certClickStep('1')
          editpage = editShow(this.certCurrentStep(), this.certClickStep())
          url = `../qualificeAudit/index.${__('locale')}.html?id=` + this.qualifyCheckId() + '&editpage=' + editpage + '&certClickStep=' + this.certClickStep()
          window.location.href = url
          break
        case '2':
          this.certClickStep('2')
          editpage = editShow(this.certCurrentStep(), this.certClickStep())
          url = `../applyFieldEdit/index.${__('locale')}.html?id=` + this.applyFieldId() + '&editpage=' + editpage + '&certClickStep=' + this.certClickStep()
          window.location.href = url
          break
        case '3':
          this.certClickStep('3')
          editpage = editShow(this.certCurrentStep(), this.certClickStep())
          url = `../productTestEdit/index.${__('locale')}.html?id=` + this.productTestId() + '&editpage=' + editpage + '&certClickStep=' + this.certClickStep()
          window.location.href = url
          break
        case '4':
          this.certClickStep('4')
          editpage = editShow(this.certCurrentStep(), this.certClickStep())
          url = `../ag_hierarchicalEdit/index.${__('locale')}.html?id=` + this.applyId() + '&editpage=' + editpage
          window.location.href = url
          break
      }
    } else {
      uMessage('warning', '请先完成之前步骤')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/progressBar/progressbar/index.js